import { gql } from '@apollo/client';
const SYNC_SPECIFICATION_VARIANTS = gql `
  mutation SyncSpecificationVariants($specificationId: ID!) {
    syncSpecificationVariants(specificationId: $specificationId) {
      createdVariants
    }
  }
`;
export default SYNC_SPECIFICATION_VARIANTS;
